import api from "shared/infra/services/api";

import { IGetConsoleTaskParams } from "../types";

const CONSOLE_GROUP_BASE_PATH = "console/groups/published";
const CONSOLE_GROUP_LESSON_BASE_PATH = "group-lessons";
const CONSOLE_GROUP_LESSON_COMMENTS_PATH = "group-lesson-comments";
const GROUP_ASSIGNMENTS_BASE_PATH = "group-assignments";
const GROUP_USERS_BASE_PATH = "select/users";
const CONSOLE_TASK_BASE_PATH = "console/assignments";
const LESSONS_SEARCH_BASE_PATH = "group-lessons";

export const consoleTaskService = {
  getAmountOfUnrevisedTasks: async ({ params = {} }) => {
    return await api.get(`${CONSOLE_TASK_BASE_PATH}/pending`, {
      params: { ...params, dontVerifyOrg: true },
    });
  },

  getGroupsUsers: async ({ params = {} }) => {
    const {
      data: { data, meta },
    } = await api.get(`${GROUP_USERS_BASE_PATH}`, {
      params: { ...params, dontVerifyOrg: true },
    });

    return { data, meta };
  },

  getConsoleGroups: async ({ params = {} }) => {
    const {
      data: { data, meta },
    } = await api.get(`${CONSOLE_GROUP_BASE_PATH}`, {
      params: { ...params, dontVerifyOrg: true },
    });

    return { data, meta };
  },

  getTask: async ({ page, ...params }: IGetConsoleTaskParams) => {
    const {
      data: { data, meta },
    } = await api.get(CONSOLE_TASK_BASE_PATH, {
      params: { page, ...removeNullKeys(params), dontVerifyOrg: true },
    });

    return { data, meta };
  },

  reviewOneTask: async ({ lessonSlug, memberId }, payload) => {
    const {
      data: { data, meta },
    } = await api.patch(
      `${CONSOLE_GROUP_LESSON_BASE_PATH}/${lessonSlug}/member/${memberId}`,
      payload,
      { params: { dontVerifyOrg: true } },
    );

    return { data, meta };
  },

  saveOneTask: async ({ group_assignment_id }) => {
    const {
      data: { data, meta },
    } = await api.patch(
      `${CONSOLE_TASK_BASE_PATH}/${group_assignment_id}`,
      null,
      { params: { dontVerifyOrg: true } },
    );

    return { data, meta };
  },

  deleteTask: async ({ group_assignment_id }) => {
    const {
      data: { data, meta },
    } = await api.delete(
      `${GROUP_ASSIGNMENTS_BASE_PATH}/${group_assignment_id}`,
      {
        params: {
          dontVerifyOrg: true,
        },
      },
    );

    return { data, meta };
  },

  answerFeedTask: async ({ payload }) => {
    return await api.post(CONSOLE_GROUP_LESSON_COMMENTS_PATH, payload, {
      params: { dontVerifyOrg: true },
    });
  },

  getConsoleGroupsLessons: async ({ params }) => {
    const {
      data: { data, meta },
    } = await api.get(LESSONS_SEARCH_BASE_PATH, {
      params: removeNullKeys(params),
    });

    return { data, meta };
  },
};

const removeNullKeys = (obj: IGetConsoleTaskParams) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([key, value]) => Boolean(value)),
  );
};
